import type { NodeViewRenderer } from '@tiptap/core';

/**
 * Node view for the `horizontalRule` node, shared by both editor twins.
 *
 * Wraps the `<hr>` in a `<div data-type="horizontalRule">`. The shared
 * stylesheet targets that wrapper (`shared/styles/partials/typography.scss`,
 * `[data-type='horizontalRule']`) to give the 1px rule a tall, `cursor-pointer`
 * hit area. Without the wrapper the stock extension renders a bare `<hr>` that
 * is practically impossible to click, so the node can't be selected.
 *
 * `name` is the extension name (`this.name`, i.e. `horizontalRule`) so the
 * emitted `data-type` matches the stylesheet selector.
 */
export const createHorizontalRuleNodeView =
  (name: string): NodeViewRenderer =>
  () => {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('data-type', name);
    const hr = document.createElement('hr');
    wrapper.appendChild(hr);

    return {
      dom: wrapper,
      contentDOM: null,
    };
  };
